import React, { createContext, useContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';

const HideOnScrollContext = createContext();

export const useHideOnScrollContext = () => {
  const context = useContext(HideOnScrollContext);
  if (!context) {
    return null; // Return null if not within provider, allowing components to work independently
  }
  return context;
};

export const HideOnScrollProvider = ({ children }) => {
  const [globalVisibility, setGlobalVisibility] = useState(true);
  const hideOnScrollRefs = useRef(new Set());

  const registerHideOnScrollRef = ref => {
    if (ref) {
      hideOnScrollRefs.current.add(ref);
    }
  };

  const unregisterHideOnScrollRef = ref => {
    hideOnScrollRefs.current.delete(ref);
  };

  const resetAllVisibility = () => {
    setGlobalVisibility(true);
    // Also reset individual instances
    hideOnScrollRefs.current.forEach(ref => {
      if (ref.current && ref.current.resetVisibility) {
        ref.current.resetVisibility();
      }
    });
  };

  const setAllHidden = isHidden => {
    setGlobalVisibility(!isHidden);
  };

  return (
    <HideOnScrollContext.Provider
      value={{
        globalVisibility,
        setGlobalVisibility,
        resetAllVisibility,
        setAllHidden,
        registerHideOnScrollRef,
        unregisterHideOnScrollRef,
      }}
    >
      {children}
    </HideOnScrollContext.Provider>
  );
};

HideOnScrollProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HideOnScrollContext;
